import React, { Component } from "react";
import { Subscribe } from "unstated";
import "./DirectionalControls.css";
import StateContainer from "../../state/StateContainer";

import DefaultButton from "../Buttons/DefaultButton/DefaultButton"
import DisplayWrapper from "../DisplayWrapper/DisplayWrapper";


class DirectionControls extends Component {
  state = {};

  render() {
    return (
      <Subscribe to={[StateContainer]}>
        {(state2) => (
          <div className="directional-controls">
            <div className="control-row">
              <DisplayWrapper displayParameter="isUpButtonShown">
                <DefaultButton
                  buttonClass="button-up"
                  buttonName="Vertical Up"
                />
              </DisplayWrapper>
            </div>
            <div className="control-row">
              <DisplayWrapper displayParameter="isLeftButtonShown">
                <DefaultButton
                  buttonClass="button-left"
                  buttonName="Horizontal Left"
                />
              </DisplayWrapper>
              <img className="three-sixty-image" src="/design/new-exports/360_icon.png" alt="" />
              <DisplayWrapper displayParameter="isRightButtonShown">
                <DefaultButton
                  buttonClass="button-right"
                  buttonName="Horizontal Right"
                />
              </DisplayWrapper>
            </div>
            <div className="control-row">
              <DisplayWrapper displayParameter="isDownButtonShown">
                <DefaultButton
                  buttonClass="button-down"
                  buttonName="Vertical Down"
                />
              </DisplayWrapper>
            </div>
          </div>
        )}
      </Subscribe>
    );
  }
}

export default DirectionControls;
